export const CAPTCHA_WIDGET_IDS = {
  DEFAULT: 'captcha_widget',
  DEFAULT_FALLBACK: 'captcha_widget_fallback',
  LOGIN: 'captcha_widget_login',
  LOGIN_FALLBACK: 'captcha_widget_login_fallback',
  SPECIAL_LINK: 'captcha_widget_special_link',
  SPECIAL_LINK_FALLBACK: 'captcha_widget_special_link_fallback',
  SPECIAL_LINK_OTP_MODAL: 'captcha_widget_special_link_otp_modal',
  SPECIAL_LINK_OTP_MODAL_FALLBACK: 'captcha_widget_special_link_otp_modal_fallback',
  BATCH_USER_MODAL: 'captcha_widget_batch_user_modal',
  BATCH_USER_MODAL_FALLBACK: 'captcha_widget_batch_user_modal_fallback',
} as const

export type CaptchaWidgetId =
  (typeof CAPTCHA_WIDGET_IDS)[keyof typeof CAPTCHA_WIDGET_IDS]
